export default __webpack_public_path__ + "static/media/finlist-highlighted.57de66c1.png";